import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import { RouteComponentProps } from '@reach/router';
import { Table } from '@organisms';
import { columns, generateRows } from './particles';
import { callGetSupportTickets } from '../../../../particles/api/extension';

const StyledContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(3)
}));

const SASupportTickets: React.FC<RouteComponentProps> = () => {
  const ticketsQuery = useQuery({
    queryKey: ['support-tickets', 1, 50],
    queryFn: () => callGetSupportTickets(1, 50)
  });

  const items =
    ticketsQuery.data?.code === 200 ? ticketsQuery.data.data?.data ?? [] : [];
  const isLoading = ticketsQuery.isFetching;
  const rows = useMemo(() => generateRows(items), [items]);

  return (
    <StyledContainer maxWidth="xl">
      <Table
        name="support-tickets"
        columns={columns}
        data={rows}
        isLoading={isLoading}
        noResultsMessage="No support tickets received yet"
        persistColumnPrefs
      />
    </StyledContainer>
  );
};

export default SASupportTickets;
